import { expectEl, Unsubs } from "./util";

export function setupGrabFor(query = "h1") {
    const unsubs = new Unsubs();
    const elem = expectEl(query);

    const MIN = 16;
    const STEP = 16;

    const onmove = (event: PointerEvent) => {
        const move = {
            x: event.movementX,
            y: event.movementY,
        };

        const moveBy = { x: 0, y: 0 };

        for (const axis of Object.keys(move) as ("x" | "y")[]) {
            if (Math.abs(move[axis]) > MIN) {
                moveBy[axis] = Math.sign(move[axis]);
            }
        }

        if (Boolean(moveBy.y)) {
            elem.style.marginTop = `${
                (parseInt(elem.style.marginTop) || 0) + moveBy.y * STEP
            }px`;
        }
        if (Boolean(moveBy.x)) {
            elem.style.marginLeft = `${
                (parseInt(elem.style.marginLeft) || 0) + moveBy.x * STEP
            }px`;
        }
    };

    document.addEventListener("pointermove", onmove);
    unsubs.add(() => document.removeEventListener("pointermove", onmove));

    return unsubs;
}
